module.exports = __webpack_public_path__ + "static/media/flower_top@2x.06720f6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro/flower_top@2x.png
// module id = 384
// module chunks = 0